export default function generateShowMoreSelectData(showMoreItem) {
  return {
    event_name: 'showMoreItem_select',
    event_category: 'showMore',
    event_action: 'select',
    event_label: showMoreItem || null,
  };
}
